<template>
  <div id="loading" v-show="loading">
    <canvas height="100" width="100" ref="canvas"></canvas>
  </div>
</template>

<script>
  import EventSystem from '../utils/EventSystem';

  export default {
    created() {
      EventSystem.$on('areas-loaded', () => {
        const minLoadTime = 600;

        setTimeout(() => {
          this.loading = false;
        }, Math.max(0, minLoadTime - (new Date().getTime() - this.loadTime)));
      });

      EventSystem.$on('front-changed', () => {
        this.loading = true;
        this.loadTime = new Date().getTime();
      });
    },
    mounted() {
      this.ctx = this.$refs.canvas.getContext('2d');
      this.ctx.fillStyle = '#222';
      this.ctx.fillRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      this.interval = setInterval(() => {
        this.redraw();
      }, 15);
    },
    beforeDestroy() {
      clearInterval(this.interval);
    },
    data() {
      return {
        ctx: null,
        rotation: 0,
        loading: true,
        loadTime: 0,
      };
    },
    methods: {
      redraw() {
        if (!loading) return;

        this.rotation += 3;

        var ctx = this.ctx;

        ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
        ctx.fillStyle = '#FFF';
        ctx.beginPath();
        ctx.arc(this.$refs.canvas.width / 2, this.$refs.canvas.height / 2, 43, 0, Math.PI * 2);
        ctx.fill();

        ctx.save();
        ctx.translate(this.$refs.canvas.width / 2, this.$refs.canvas.height / 2);

        ctx.save();
        ctx.fillStyle = '#01CC9B';
        ctx.rotate(this.rotation * (Math.PI / 180));
        ctx.beginPath();
        ctx.arc(0, 20, 13, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();

        ctx.save();
        ctx.fillStyle = '#FF3C1B';
        ctx.rotate((this.rotation + 120) * (Math.PI / 180));
        ctx.beginPath();
        ctx.arc(0, 20, 15, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();

        ctx.save();
        ctx.fillStyle = '#276CD7';
        ctx.rotate((this.rotation + 240) * (Math.PI / 180));
        ctx.beginPath();
        ctx.arc(0, 20, 17, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();

        ctx.restore();
      },
    }
  };
</script>



// WEBPACK FOOTER //
// assets/js/source/vue-ui/loading.vue